import acl from './acl'

const aclPlugin = {

  install(Vue, options) {
    Vue.prototype.$acl = acl
  }
};

export default aclPlugin;
